<template>
  <div>
    <With_Header_Modal_Template title="Детали бронирования">
      <div class="details">
        <div class="details_content">
          <custom-input placeholder="Название" mb="15px"/>
          <custom-input mb="15px"/>
          <custom-input mb="15px"/>
          <div class="time_picker">
            <custom-input type="time"/>
            <span class="line_between">—</span>
            <custom-input type="time"/>
          </div>
        </div>
      </div>
      <div class="details_cancel">
        <button @click="isVisibleModal = true">Отменить бронирование</button>
      </div>
    </With_Header_Modal_Template>
    <transition name="fade">
      <div class="subModal" v-if="isVisibleModal" @click="modalClose" ref="modalBg">
      <div class="subModal_body">
        <div class="subModal_body-content">
          <button class="close_btn" @click="isVisibleModal = false">
            <img src="../../../../assets/images/icons/close.svg" alt="">
          </button>
          <p>Вы действительно хотите отменить это бронирование?</p>
        </div>
        <div class="subModal_footer">
          <button>Не отменять</button>
          <button>Да, отменить</button>
        </div>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
import With_Header_Modal_Template from '@/components/Modals/ModalsTemplate/With_Header_Modal_Template'
import CustomInput from '@/components/ui/inputs/custom-input'

export default {
  name: "DetailsOfBooking",
  components: {CustomInput, With_Header_Modal_Template},
  data: () => ({
    isVisibleModal: false
  }),
  methods: {
    modalClose (e) {
      if (e.target === this.$refs.modalBg) {
        this.isVisibleModal = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.details {
  padding: 20px 15px;

  &_content {
    height: calc(100vh - 170px);
    margin-bottom: 20px;
    overflow: auto;
  }

  &_cancel {
    text-align: center;
    button {
      background-color: transparent;
      border: none;
      font-weight: 600;
      font-size: 16px;
      color: #E05252;
    }
  }
}

.time_picker {
  display: flex;
  align-items: center;
  .line_between {
    margin: 0 7px;
  }
}

.subModal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;

  &_body {
    width: 290px;
    background-color: #FFFFFF;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.04), 0 2px 6px rgba(0, 0, 0, 0.04), 0 0 1px rgba(0, 0, 0, 0.04);
    border-radius: 10px;

    &-content {
      height: 155px;
      padding: 0 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      position: relative;
      p {
        font-size: 16px;
        line-height: 1.5;
        color: #383838;
      }
    }

    .close_btn {
      position: absolute;
      width: 20px;
      height: 20px;
      background-color: transparent;
      border: none;
      right: 10px;
      top: 10px;
      img {
        max-width: 100%;
      }
    }

  }

  &_footer {
    display: flex;
    border-top: 1px solid #E5E5E5;
    button {
      height: 48px;
      width: 50%;
      border: none;
      background-color: transparent;
      font-size: 16px;
      text-align: center;
      color: #383838;
      &:first-child {
        color: #808080;
        border-right: 1px solid #E5E5E5;
      }
    }
  }
}

</style>
